module.exports = __webpack_public_path__ + "img/32.a45bd8b7.jpg";